import { EmptyItem } from "./EmptyItem";
import { Item } from "./Item";
import { Loader } from "./Loader";
import { Root } from "./Root";

export const GridSuggestionMenu = {
  Root,
  Item,
  EmptyItem,
  Loader,
};
